import { create } from 'zustand'

/**
 * Whether the graph, the sidebar and the entity detail show what an analyst marked as no longer
 * valid or wrong (PRD-0075 R-C4). Hidden by default; shown, it is drawn greyed. One switch for
 * every view of the session, never persisted: a reload hides them again.
 */
interface FactVisibilityState {
  showNoLongerValid: boolean
  setShowNoLongerValid: (show: boolean) => void
}

export const useFactVisibilityStore = create<FactVisibilityState>(set => ({
  showNoLongerValid: false,
  setShowNoLongerValid: show => set({ showNoLongerValid: show }),
}))
